export const INITIALIZE_USER_CRED = "INITIALIZE_USER_CRED";